import { ArrowDown } from 'lucide-react';
import './SchoolAdmissionSection.css';

export default function SchoolAdmissionSection() {
	return (
		<section className='school-admission'>
			<div className='school-admission__overlay' />

			<div className='school-admission__container'>
				<div className='school-admission__content'>
					<h2 className='school-admission__title'>
						Choisissez votre spécialisation
					</h2>

					<span className='school-admission__divider' />

					<p className='school-admission__text'>
						Clevory Academy propose deux parcours stratégiques : IT Sales et
						Intelligence Artificielle. Chaque programme est conçu pour répondre
						aux besoins du marché et vous rendre opérationnel rapidement grâce à
						une approche pratique et professionnalisante.
					</p>

					<a href='#bas' className='school-admission__button'>
						<span className='school-admission__button-fill' />
						<span className='school-admission__button-text'>
							<ArrowDown className='school-admission__button-icon' />
						</span>
					</a>
				</div>
			</div>
		</section>
	);
}
